import { Box, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Color } from 'src/theme/color';

export interface CartridgeAttribute {
	label: string;
	value: string;
}

interface Props {
	attributes: CartridgeAttribute[];
	color: string;
}

export const CartridgeAttributes: FC<Props> = ({ attributes, color }) => {
	const { t } = useTranslation();

	return (
		<Flex
			gridGap="20px"
			mt="30px"
			mb="10px"
		>
			{attributes.map(attribute => {
				return (
					<Flex
						gap="10px"
						flexDir="column"
						align="center"
						key={attribute.label}
					>
						<Box
							textAlign="center"
							minW="200px"
							textTransform="uppercase"
							color={Color.GRAY_2}
						>
							{t(attribute.label)}
						</Box>
						<Text
							fontSize="14px"
							position="relative"
							textAlign="center"
						>
							{t(attribute.value)}
						</Text>
					</Flex>
				);
			})}
		</Flex>
	);
};
